import i18n from '@/shared/i18n';

/**
 * Gets the section header for the Overview section in the automation editor.
 * Contains the translated "Overview" text with markdown heading format.
 * @returns The markdown heading for the Overview section
 */
export function getOverviewSectionHeader(): string {
  return `### ${i18n.t('automation.editor.section.overview', { ns: 'automation' })}`;
}

/**
 * Gets the section header for the Execution Steps section in the automation editor.
 * Contains the translated "Execution Steps" text with markdown heading format.
 * @returns The markdown heading for the Execution Steps section
 */
export function getExecutionStepsSectionHeader(): string {
  return `### ${i18n.t('automation.editor.section.executionSteps', { ns: 'automation' })}`;
}

/**
 * Canonical chat command the user dispatches by clicking the
 * "Add to Resolution Playbook" button on a resolved exception. Sent verbatim
 * as the user's chat message; the astral agent recognizes it through its
 * `guide-resolution` skill's English trigger aliases (which include both
 * "resolution playbook" and the legacy "troubleshooting guide" phrasing).
 *
 * Intentionally NOT routed through i18n — the agent prompt is English, so the
 * payload must stay English regardless of the UI locale. The user-visible
 * button label is the i18n-translated string
 * `automation.runAssistant.addToResolutionPlaybook`.
 */
export const ADD_TO_RESOLUTION_PLAYBOOK_COMMAND = 'Add to Resolution Playbook';
